async function getUsers (options) {
    return this.api({
        url: `/users/`,
        method: 'GET',
        params: { ...options }
    })
}

async function getUsersRoles () {
    return this.api({
        url: `/users/roles`,
        method: 'GET'
    })
}

async function getUserCreate () {
    return this.api({
        url: `/users/create`,
        method: 'GET'
    })
}

async function getUsersEdit () {
    return this.api({
        url: `/users/edit`,
        method: 'GET'
    })
}

async function postUser (user) {
    return this.api({
        url: `/users/`,
        method: 'POST',
        data: user
    })
}

async function getUser ( id ) {
    return this.api({
        url: `/users/${id}`,
        method: 'GET'
    })
}

async function getUserEdit ( id ) {
    return this.api({
        url: `/users/${id}/edit`,
        method: 'GET'
    })
}

async function editUser (id, options) {
    return this.api({
        url: `/users/${id}`,
        method: 'PATCH',
        data: options
    })
}

async function getUserRolesEdit ( id ) {
    return this.api({
        url: `/users/${id}/roles/edit`,
        method: 'GET'
    })
}

async function editUserRoles (id, roles) {
    return this.api({
        url: `/users/${id}/roles`,
        method: 'PUT',
        data: roles
    })
}
 
 export default {
     pluginName: 'user',
     methods: {
        getUsers, getUsersRoles, getUserCreate, getUsersEdit, postUser,
        getUser, getUserEdit, editUser, getUserRolesEdit, editUserRoles
     },
     apiMessages: {
     }
 }